import {
  Dialog, IconButton, useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Close from '@mui/icons-material/Close';
import { UsernameForm } from 'components/UsernameModal/UsernameForm';

interface Props {
  saveLabel: string;
  onSave: () => void;
  info?: string;
  onCancel?: () => void;
  onSkip?: () => void;
}

export const UsernameModal = ({
  saveLabel, info, onSave, onCancel, onSkip,
}: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog open fullScreen={isMobile} maxWidth="lg">
      {onCancel && (
        <div className="absolute right-2 top-2">
          <IconButton
            aria-label="close"
            onClick={onCancel}
          >
            <Close />
          </IconButton>
        </div>
      )}
      <UsernameForm
        saveLabel={saveLabel}
        info={info}
        onSave={onSave}
        onCancel={onCancel}
        onSkip={onSkip}
      />
    </Dialog>
  );
};
